export default __webpack_public_path__ + "static/assets/c376ac42ba0eee3464129a7b7d9a9d0c.gif";